import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {ClientRequest} from "../../common/ClientRequest";
import {removeExchangeCode, removeRefreshToken, removeToken, saveRefreshToken, saveToken} from "../../common/Storage";
import {RootState} from "../store";

interface AppState {
    userInfo: any,
    getVoucher: any
}

const initialState: AppState = {
    userInfo: null,
    getVoucher: null
};

const appSlice = createSlice({
    name: 'appSlice',
    initialState,
    reducers: {
        actionLogout: (state) => {
            state.userInfo = null;
            state.getVoucher = null;
            removeExchangeCode();
            removeToken();
            removeRefreshToken();
        },
    },
    extraReducers: builder => {
        builder.addCase(refreshTokenThunk.fulfilled, (state, action) => {
            if (action.payload?.code === 0) {
                saveToken(action.payload?.data?.access_token);
                saveRefreshToken(action.payload?.data?.refresh_token)
            }
        });
        builder.addCase(getUserInfoThunk.fulfilled, (state, action) => {
            if (action.payload?.code === 0) {
                state.userInfo = action.payload?.data;
            }
        });
        builder.addCase(getVoucherThunk.fulfilled, (state, action) => {
            state.getVoucher = action.payload;
        });
    }
});

export const refreshTokenThunk = createAsyncThunk(
    "app/refreshTokenThunk",
    async (exchangeCode: string, thunkAPI) => {
        return await ClientRequest("/user-service/v3/auth/refreshtoken", {jwt: exchangeCode}) as any;
    }
)

export const refreshExchangeTokenThunk = createAsyncThunk(
    "app/refreshExchangeTokenThunk",
    async (rfToken: string, thunkAPI) => {
        return await ClientRequest("/user-service/v3/auth/refreshtoken", {jwt: rfToken, rTokenType: 2}) as any;
    }
)

export const getUserInfoThunk = createAsyncThunk(
    "app/getUserInfoThunk",
    async (token: string) => {
        return await ClientRequest("/user-service/v3/User/getuserinfo", {token: token}) as any;
    }
)

export const getVoucherThunk = createAsyncThunk(
    "app/getVoucherThunk",
    async (params: {
        api_key: string,
        tel: string,
        serviceCode: string,
        userId: number,
        token: string,
        IPClient: string,
        deviceId: string,
        sign: string,
        deltatime: number,
        redirectUrl: string
    }) => {
        return await ClientRequest("/betia-service/v2/eventRegister/getVoucherBaVi", params) as any;
    }
)

export const appReducer = appSlice.reducer;
export const {actionLogout} = appSlice.actions;
export const selectUserInfo = (state: RootState) => state.app.userInfo;
export const selectUserId = (state: RootState) => state.app.userInfo?.pk_user_id;
export const selectEduType = (state: RootState) => state.app.userInfo?.lstUserPosition?.[0]?.edu_user_type;
export const selectVillageId = (state: RootState) => state.app.userInfo?.lstUserPosition?.[0]?.fk_village_id;
export const selectGetVoucher = (state: RootState) => state.app.getVoucher;
